module.exports = __webpack_public_path__ + "img/home_banner_3.af48705a.png";